var _SDBContentSplitButton_primaryLabel_accessor_storage, _SDBContentSplitButton_primaryAction_accessor_storage, _SDBContentSplitButton_actions_accessor_storage, _SDBContentSplitButton_icon_accessor_storage, _SDBContentSplitButton_iconSize_accessor_storage, _SDBContentSplitButton_iconOnly_accessor_storage, _SDBContentSplitButton_padding_accessor_storage, _SDBContentSplitButton_paddingSplitButton_accessor_storage, _SDBContentSplitButton_secondary_accessor_storage, _SDBContentSplitButton_themecolor_accessor_storage, _SDBContentSplitButton_media_accessor_storage, _SDBContentSplitButton_disabled_accessor_storage, _SDBContentSplitButton_locked_accessor_storage, _SDBContentSplitButton_outlined_accessor_storage, _SDBContentSplitButton_light_accessor_storage, _SDBContentSplitButton_menuDismissible_accessor_storage, _SDBContentSplitButton_menuPosition_accessor_storage, _SDBContentSplitButton_popoverMenuOpened_accessor_storage;
import { __classPrivateFieldGet, __classPrivateFieldSet, __decorate } from "tslib";
import { LitElement, html, css, nothing } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { map } from 'lit/directives/map.js';
import { styleMap } from 'lit/directives/style-map.js';
import { elements } from './sdb-elements.js';
import '@vaadin/popover/theme/material/vaadin-popover.js';
import { popoverRenderer } from '@vaadin/popover/lit.js';
/**
 * Button element
 *
 * @prop {SplitButtonAction[]} actions - mandatory, all secondary actions
 * @prop {String} primaryLabel - mandatory, used to define the primary button text
 * @prop {String} primaryAction - mandatory, action for the primary button to execute

 * @prop {String} icon - optional, used to set an icon at the beginning of the primary button
 * @prop {String} iconSize - optional, used to set the size of the icon (default 20)
 * @prop {String} padding - optional, used to set the padding of the buttons (default 10px 15px)
 *
 * @prop {Boolean} secondary - optional, displays the buttons in the secondary color
 * @prop {Boolean} themecolor - optional, displays the buttons in the active themecolor
 * @prop {Boolean} outlined - optional, used to display a bordered button (no fill)
 * @prop {Boolean} media - optional, lightgrey button with icon in primary themecolor
 * @prop {Boolean} light - optional, displays text in text-light color
 * @prop {Boolean} disabled - optional, disables the button (also removes all pointer events)
 * @prop {Boolean} locked - optional, overlays the button with a lock layer (also removes pointer events)
 * @prop {Boolean} iconOnly - optional, used for buttons that only show an icon (removes margin)
 * @prop {Boolean} menuDismissible - optional, makes the popover menu non modal so it will dissappear after a click
 * @prop {Boolean} menuPosition - optional, vaadin position [start, end, top, bottom, bottom-start, etc]
 *
 */
let SDBContentSplitButton = class SDBContentSplitButton extends LitElement {
    constructor() {
        super(...arguments);
        _SDBContentSplitButton_primaryLabel_accessor_storage.set(this, '');
        _SDBContentSplitButton_primaryAction_accessor_storage.set(this, null);
        _SDBContentSplitButton_actions_accessor_storage.set(this, []);
        _SDBContentSplitButton_icon_accessor_storage.set(this, '');
        _SDBContentSplitButton_iconSize_accessor_storage.set(this, '18');
        _SDBContentSplitButton_iconOnly_accessor_storage.set(this, false);
        _SDBContentSplitButton_padding_accessor_storage.set(this, '10px 15px');
        _SDBContentSplitButton_paddingSplitButton_accessor_storage.set(this, '8px 10px 10px 10px');
        _SDBContentSplitButton_secondary_accessor_storage.set(this, false);
        _SDBContentSplitButton_themecolor_accessor_storage.set(this, false);
        _SDBContentSplitButton_media_accessor_storage.set(this, false);
        _SDBContentSplitButton_disabled_accessor_storage.set(this, false);
        _SDBContentSplitButton_locked_accessor_storage.set(this, false);
        _SDBContentSplitButton_outlined_accessor_storage.set(this, false);
        _SDBContentSplitButton_light_accessor_storage.set(this, false);
        _SDBContentSplitButton_menuDismissible_accessor_storage.set(this, false);
        _SDBContentSplitButton_menuPosition_accessor_storage.set(this, 'bottom-start');
        _SDBContentSplitButton_popoverMenuOpened_accessor_storage.set(this, false);
    }
    get primaryLabel() { return __classPrivateFieldGet(this, _SDBContentSplitButton_primaryLabel_accessor_storage, "f"); }
    set primaryLabel(value) { __classPrivateFieldSet(this, _SDBContentSplitButton_primaryLabel_accessor_storage, value, "f"); }
    get primaryAction() { return __classPrivateFieldGet(this, _SDBContentSplitButton_primaryAction_accessor_storage, "f"); }
    set primaryAction(value) { __classPrivateFieldSet(this, _SDBContentSplitButton_primaryAction_accessor_storage, value, "f"); }
    get actions() { return __classPrivateFieldGet(this, _SDBContentSplitButton_actions_accessor_storage, "f"); }
    set actions(value) { __classPrivateFieldSet(this, _SDBContentSplitButton_actions_accessor_storage, value, "f"); }
    get icon() { return __classPrivateFieldGet(this, _SDBContentSplitButton_icon_accessor_storage, "f"); }
    set icon(value) { __classPrivateFieldSet(this, _SDBContentSplitButton_icon_accessor_storage, value, "f"); }
    get iconSize() { return __classPrivateFieldGet(this, _SDBContentSplitButton_iconSize_accessor_storage, "f"); }
    set iconSize(value) { __classPrivateFieldSet(this, _SDBContentSplitButton_iconSize_accessor_storage, value, "f"); }
    get iconOnly() { return __classPrivateFieldGet(this, _SDBContentSplitButton_iconOnly_accessor_storage, "f"); }
    set iconOnly(value) { __classPrivateFieldSet(this, _SDBContentSplitButton_iconOnly_accessor_storage, value, "f"); }
    get padding() { return __classPrivateFieldGet(this, _SDBContentSplitButton_padding_accessor_storage, "f"); }
    set padding(value) { __classPrivateFieldSet(this, _SDBContentSplitButton_padding_accessor_storage, value, "f"); }
    get paddingSplitButton() { return __classPrivateFieldGet(this, _SDBContentSplitButton_paddingSplitButton_accessor_storage, "f"); }
    set paddingSplitButton(value) { __classPrivateFieldSet(this, _SDBContentSplitButton_paddingSplitButton_accessor_storage, value, "f"); }
    get secondary() { return __classPrivateFieldGet(this, _SDBContentSplitButton_secondary_accessor_storage, "f"); }
    set secondary(value) { __classPrivateFieldSet(this, _SDBContentSplitButton_secondary_accessor_storage, value, "f"); }
    get themecolor() { return __classPrivateFieldGet(this, _SDBContentSplitButton_themecolor_accessor_storage, "f"); }
    set themecolor(value) { __classPrivateFieldSet(this, _SDBContentSplitButton_themecolor_accessor_storage, value, "f"); }
    get media() { return __classPrivateFieldGet(this, _SDBContentSplitButton_media_accessor_storage, "f"); }
    set media(value) { __classPrivateFieldSet(this, _SDBContentSplitButton_media_accessor_storage, value, "f"); }
    get disabled() { return __classPrivateFieldGet(this, _SDBContentSplitButton_disabled_accessor_storage, "f"); }
    set disabled(value) { __classPrivateFieldSet(this, _SDBContentSplitButton_disabled_accessor_storage, value, "f"); }
    get locked() { return __classPrivateFieldGet(this, _SDBContentSplitButton_locked_accessor_storage, "f"); }
    set locked(value) { __classPrivateFieldSet(this, _SDBContentSplitButton_locked_accessor_storage, value, "f"); }
    get outlined() { return __classPrivateFieldGet(this, _SDBContentSplitButton_outlined_accessor_storage, "f"); }
    set outlined(value) { __classPrivateFieldSet(this, _SDBContentSplitButton_outlined_accessor_storage, value, "f"); }
    get light() { return __classPrivateFieldGet(this, _SDBContentSplitButton_light_accessor_storage, "f"); }
    set light(value) { __classPrivateFieldSet(this, _SDBContentSplitButton_light_accessor_storage, value, "f"); }
    get menuDismissible() { return __classPrivateFieldGet(this, _SDBContentSplitButton_menuDismissible_accessor_storage, "f"); }
    set menuDismissible(value) { __classPrivateFieldSet(this, _SDBContentSplitButton_menuDismissible_accessor_storage, value, "f"); }
    get menuPosition() { return __classPrivateFieldGet(this, _SDBContentSplitButton_menuPosition_accessor_storage, "f"); }
    set menuPosition(value) { __classPrivateFieldSet(this, _SDBContentSplitButton_menuPosition_accessor_storage, value, "f"); }
    get popoverMenuOpened() { return __classPrivateFieldGet(this, _SDBContentSplitButton_popoverMenuOpened_accessor_storage, "f"); }
    set popoverMenuOpened(value) { __classPrivateFieldSet(this, _SDBContentSplitButton_popoverMenuOpened_accessor_storage, value, "f"); }
    render() {
        return html `
            <div class="container">
                <button
                    id="sb_primary_button"
                    class="button"
                    ?disabled=${this.disabled}
                    style=${styleMap({ padding: this.padding })}
                    @click=${this.primaryAction}
                >
                    ${this.locked
            ? html ` <div class="lockedOverlay">
                              <sdb-content-icon
                                  size="24"
                                  icon="fal fa-lock"
                              ></sdb-content-icon>
                          </div>`
            : nothing}
                    ${this.icon
            ? html ` <sdb-content-icon
                              size=${this.iconSize}
                              .icon=${this.icon}
                          ></sdb-content-icon>`
            : nothing}
                    ${this.primaryLabel}
                </button>
                <button
                    id="sb_popover_button"
                    class="button"
                    ?disabled=${this.disabled}
                    style=${styleMap({ padding: this.paddingSplitButton })}
                >
                    ${this.locked
            ? html ` <div class="lockedOverlay"></div>`
            : nothing}
                    <sdb-content-icon
                        class="rotated-icon ${this.popoverMenuOpened
            ? 'up'
            : 'down'}"
                        size="16"
                        icon="fal fa-chevron-down"
                    ></sdb-content-icon>
                </button>
                <vaadin-popover
                    id="sb_menu"
                    for="sb_popover_button"
                    modal
                    overlay-role="menu"
                    position=${this.menuPosition}
                    theme="no-padding"
                    ?opened=${this.popoverMenuOpened}
                    @opened-changed=${(e) => {
            this.popoverMenuOpened = e.detail.value;
        }}
                    .trigger=${['click']}
                    ${popoverRenderer(() => html ` <style>
                                    .popover-container {
                                        display: flex;
                                        flex-direction: column;
                                    }
                                    .popover-button {
                                        text-transform: uppercase;
                                        background: var(
                                            --popover-background-color
                                        );
                                        color: var(--popover-background-color);
                                        padding: 10px 15px;
                                        border: none;
                                        cursor: pointer;
                                        text-align: left;
                                    }
                                    .popover-button:hover {
                                        background: rgba(0, 0, 0, 0.1);
                                    }
                                </style>
                                <div
                                    class="popover-container"
                                    @click=${() => {
            this.popoverMenuOpened =
                !this.menuDismissible;
        }}
                                >
                                    ${map(this.actions, (action) => html `
                                            <button
                                                class="popover-button"
                                                ?disabled=${action.disabled}
                                                @click=${action.action}
                                            >
                                                ${action.icon
            ? html ` <sdb-content-icon
                                                          size="24"
                                                          .icon=${action.icon}
                                                      ></sdb-content-icon>`
            : nothing}
                                                ${action.label}
                                            </button>
                                        `)}
                                </div>`, [this.actions])}
                >
                </vaadin-popover>
            </div>
        `;
    }
};
_SDBContentSplitButton_primaryLabel_accessor_storage = new WeakMap();
_SDBContentSplitButton_primaryAction_accessor_storage = new WeakMap();
_SDBContentSplitButton_actions_accessor_storage = new WeakMap();
_SDBContentSplitButton_icon_accessor_storage = new WeakMap();
_SDBContentSplitButton_iconSize_accessor_storage = new WeakMap();
_SDBContentSplitButton_iconOnly_accessor_storage = new WeakMap();
_SDBContentSplitButton_padding_accessor_storage = new WeakMap();
_SDBContentSplitButton_paddingSplitButton_accessor_storage = new WeakMap();
_SDBContentSplitButton_secondary_accessor_storage = new WeakMap();
_SDBContentSplitButton_themecolor_accessor_storage = new WeakMap();
_SDBContentSplitButton_media_accessor_storage = new WeakMap();
_SDBContentSplitButton_disabled_accessor_storage = new WeakMap();
_SDBContentSplitButton_locked_accessor_storage = new WeakMap();
_SDBContentSplitButton_outlined_accessor_storage = new WeakMap();
_SDBContentSplitButton_light_accessor_storage = new WeakMap();
_SDBContentSplitButton_menuDismissible_accessor_storage = new WeakMap();
_SDBContentSplitButton_menuPosition_accessor_storage = new WeakMap();
_SDBContentSplitButton_popoverMenuOpened_accessor_storage = new WeakMap();
SDBContentSplitButton.styles = [
    elements,
    css `
            :host .container {
                position: relative;
                display: flex;
                align-items: center;
                margin: 5px 5px 5px 0;
                -webkit-transform: rotateZ(360deg);
            }

            button.button {
                position: relative;
                background: var(--btn-primary);
                color: var(--btn-primary-text);
                text-transform: uppercase;
                border: none;
                cursor: pointer;
                font: var(--font-default);
            }

            #sb_primary_button {
                display: inline-flex;
                align-items: center;
            }

            #sb_primary_button sdb-content-icon {
                margin-right: 10px;
            }

            #sb_popover_button {
                margin-left: 1px;
                border-left-style: solid;
                border-left-width: 1px;
                border-left-color: transparent;
            }

            :host:focus {
                outline: none !important;
            }

            :host .button:hover {
                transform: var(--sdb-button-scale-factor, scale(1.05));
            }

            :host([locked]) .button .lockedOverlay {
                display: flex;
                position: absolute;
                background: RGBA(255, 255, 255, 0.75);
                width: 100%;
                height: 100%;
                top: 0;
                left: 0;
                align-items: center;
                justify-content: center;
                color: var(--text-primary);
            }

            :host([iconOnly]) .button sdb-content-icon {
                margin-right: 0;
            }

            :host([themecolor]) .button {
                background: var(--theme-primary);
                color: var(--theme-primary-text);
            }

            :host([secondary]) .button {
                background: var(--btn-secondary);
                color: var(--btn-secondary-text);
            }

            :host([media]) .button {
                background: var(--element-lightgrey);
                color: var(--text-primary);
            }

            :host([media]) #sb_primary_button sdb-content-icon {
                color: var(--theme-primary);
            }

            :host([disabled]),
            :host([locked]) {
                pointer-events: none;
            }

            :host([outlined]) .button {
                background: transparent;
                border: 1px solid var(--element-grey);
                color: var(--text-primary);
            }

            :host([outlined]) .button:hover {
                background: rgba(0, 0, 0, 0.1);
            }

            :host([outlined]) #sb_primary_button {
                border-right: none;
            }

            :host([outlined]) #sb_popover_button {
                border-color: var(--element-grey);
            }

            :host([light]) #sb_popover_button {
                color: var(--text-light);
            }

            :host([light]) .button:hover {
                color: var(--text-light);
            }

            :host([disabled]) .button {
                color: var(--element-disabled);
                background: var(--btn-disabled);
            }

            :host([disabled]) #sb_popover_button {
                color: var(--element-disabled);
            }

            .rotated-icon.up {
                transform: rotate(180deg);
                transition: 0.2s ease-in;
            }

            .rotated-icon.down {
                transform: rotate(0deg);
                transition: 0.2s ease-in;
            }
        `,
];
__decorate([
    property({ type: String })
], SDBContentSplitButton.prototype, "primaryLabel", null);
__decorate([
    property({ type: Function })
], SDBContentSplitButton.prototype, "primaryAction", null);
__decorate([
    property({ type: Array })
], SDBContentSplitButton.prototype, "actions", null);
__decorate([
    property({ type: String })
], SDBContentSplitButton.prototype, "icon", null);
__decorate([
    property({ type: String })
], SDBContentSplitButton.prototype, "iconSize", null);
__decorate([
    property({ type: Boolean })
], SDBContentSplitButton.prototype, "iconOnly", null);
__decorate([
    property({ type: String })
], SDBContentSplitButton.prototype, "padding", null);
__decorate([
    property({ type: String })
], SDBContentSplitButton.prototype, "paddingSplitButton", null);
__decorate([
    property({ type: Boolean })
], SDBContentSplitButton.prototype, "secondary", null);
__decorate([
    property({ type: Boolean })
], SDBContentSplitButton.prototype, "themecolor", null);
__decorate([
    property({ type: Boolean })
], SDBContentSplitButton.prototype, "media", null);
__decorate([
    property({ type: Boolean, reflect: true })
], SDBContentSplitButton.prototype, "disabled", null);
__decorate([
    property({ type: Boolean, reflect: true })
], SDBContentSplitButton.prototype, "locked", null);
__decorate([
    property({ type: Boolean })
], SDBContentSplitButton.prototype, "outlined", null);
__decorate([
    property({ type: Boolean })
], SDBContentSplitButton.prototype, "light", null);
__decorate([
    property({ type: Boolean })
], SDBContentSplitButton.prototype, "menuDismissible", null);
__decorate([
    property({ type: String })
], SDBContentSplitButton.prototype, "menuPosition", null);
__decorate([
    state()
], SDBContentSplitButton.prototype, "popoverMenuOpened", null);
SDBContentSplitButton = __decorate([
    customElement('sdb-content-split-button')
], SDBContentSplitButton);
export { SDBContentSplitButton };
//# sourceMappingURL=sdb-content-split-button.js.map